import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CorrectionFactor from './correction-factor';
import CorrectionFactorDetail from './correction-factor-detail';
import CorrectionFactorUpdate from './correction-factor-update';
import CorrectionFactorDeleteDialog from './correction-factor-delete-dialog';

const CorrectionFactorRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CorrectionFactor />} />
    <Route path="new" element={<CorrectionFactorUpdate />} />
    <Route path=":id">
      <Route index element={<CorrectionFactorDetail />} />
      <Route path="edit" element={<CorrectionFactorUpdate />} />
      <Route path="delete" element={<CorrectionFactorDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CorrectionFactorRoutes;
